import React, { useEffect, useState } from 'react';
import { Link, NavLink, withRouter } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import ScrollToStart from '../UI/ScrollToStart';
import Logo from '../../../assets/img/logo.png';
import LogoWhite from '../../../assets/img/logo-white.png';
import userImage from '../../../assets/img/placeHolderImage.png';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';
import { logoutUser } from '../../redux/user/UserActions';
import { applicationUserType } from '../../helpers/constants';
import config from '../../../config';
import { useGoogleAnalytics } from '../../helpers/customHooks';
// import WebinarBanner from '../global/WebinarBanner';

const PublicHeader = (props) => {
  const [addHeaderClass, setHeaderClass] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  let history = useHistory();

  useEffect(() => {
    const calculateHeader = (e) => {
      if (window.scrollY >= 100) {
        setHeaderClass(true);
      } else {
        setHeaderClass(false);
      }
    };
    window.addEventListener('scroll', calculateHeader);

    return () => {
      window.removeEventListener('scroll', calculateHeader);
    };
  }, []);
  const closeMobileMenu = () => {
    setMobileMenu(false);
  };

  // track pageview with google analytics
  useGoogleAnalytics();

  const currentPath = window.location.pathname;
  const servicesMenuActive =
    currentPath === '/importers-landing' ||
    currentPath === '/clearing-agents-landing' ||
    currentPath === '/forwarding-agents-landing';

  return (
    <>
      {/* THIS IS COMMENTED FOR THE TIME BEING  */}
      {/* <WebinarBanner /> */}
      <header
        id="header"
        className={`header fixed-top ${
          addHeaderClass ? 'header-scrolled' : ''
        } ${props.defaultClass || ''}`}
      >
        <div className="container-fluid container-xl d-flex align-items-center justify-content-between">
          <Link to="/" className="logo d-flex align-items-center">
            {addHeaderClass ? (
              <img src={LogoWhite} alt="goagent-logo" />
            ) : (
              <img src={Logo} alt="goagent-logo" />
            )}
          </Link>

          <nav id="navbar" className={`navbar ${mobileMenu ? 'navbar-mobile' : ''}`}>
            <ul>
              <li onClick={closeMobileMenu}>
                <NavLink to="/" className="nav-link" exact>
                  Home
                </NavLink>
              </li>
              <li onClick={closeMobileMenu}>
                <NavLink to="/about-us" className="nav-link">
                  About Us
                </NavLink>
              </li>
              <li className="dropdown">
                <a className={`dropbtn nav-link ${servicesMenuActive ? 'active' : ''}`}>Services</a>
                <div className="dropdown-content">
                  <NavLink to="/importers-landing" className="nav-link" onClick={closeMobileMenu}>
                    GoAgent for Importers
                  </NavLink>

                  <NavLink
                    to="/clearing-agents-landing"
                    className="nav-link"
                    onClick={closeMobileMenu}
                  >
                    GoAgent for Clearing Agents
                  </NavLink>

                  <NavLink
                    to="/forwarding-agents-landing"
                    className="nav-link"
                    onClick={closeMobileMenu}
                  >
                    GoAgent for Transporters
                  </NavLink>
                </div>
              </li>
              <li onClick={closeMobileMenu}>
                <NavLink to="/career" className="nav-link">
                  Careers
                </NavLink>
              </li>
              <li onClick={closeMobileMenu}>
                <NavLink to="/blog" className="nav-link">
                  Blog
                </NavLink>
              </li>
              <li onClick={closeMobileMenu}>
                <NavLink to="/contact-us" className="nav-link">
                  Contact
                </NavLink>
              </li>

              {!get(user, 'isLoggedIn', false) && (
                <li onClick={closeMobileMenu}>
                  <NavLink to="/login" className="nav-link">
                    Login
                  </NavLink>
                </li>
              )}
              {!get(user, 'isLoggedIn', false) && (
                <li onClick={closeMobileMenu}>
                  <NavLink to="/registration" className="active nav-link">
                    Create Free Account
                  </NavLink>
                </li>
              )}
            </ul>
            <i
              className={`bi bi-${mobileMenu ? 'x' : 'list'} mobile-nav-toggle`}
              onClick={() => setMobileMenu(!mobileMenu)}
            ></i>
          </nav>

          {get(user, 'isLoggedIn', false) && (
            <>
              {' '}
              <div className="loginright">
                <a
                  href="#"
                  className="topprofile"
                  id="dropdownMenu1"
                  data-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    src={
                      get(user, 'avatar')
                        ? `${config.api.URL.replace('/api/v1', '')}/${get(user, 'avatar')}`
                        : userImage
                    }
                    alt=""
                  />
                </a>
                <ul 
                  className="dropdown-menu dropdown-menu-right" 
                  aria-labelledby="dropdownMenu1"
                  style={{
                    borderRadius: '12px',
                    padding: '0',
                    minWidth: 'auto',
                    width: 'max-content',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
                    border: 'none',
                    overflow: 'hidden',
                    marginTop: '10px',
                    right: '0',
                    left: 'auto',
                    transform: 'translateX(-40px)'
                  }}
                >
                  <div style={{ padding: '1rem', background: 'linear-gradient(135deg, #007679 0%, #01a8af 100%)', color: 'white' }}>
                    <div className="d-flex align-items-center">
                      <img
                        src={
                          get(user, 'avatar')
                            ? `${config.api.URL.replace('/api/v1', '')}/${get(user, 'avatar')}`
                            : userImage
                        }
                        alt=""
                        style={{ width: '45px', height: '45px', borderRadius: '50%', border: '2px solid rgba(255,255,255,0.8)', objectFit: 'cover' }}
                      />
                      <div style={{ marginLeft: '12px', paddingRight: '10px' }}>
                        <p className="mb-0 fw-bold text-white" style={{ fontSize: '1.4rem', lineHeight: '1.2' }}>{get(user, 'first_name') ? `${get(user, 'first_name')} ${get(user, 'last_name')}` : 'User'}</p>
                        <p className="mb-0" style={{ fontSize: '1.1rem', color: 'rgba(255,255,255,0.85)', marginTop: '4px' }}>
                          ID: {get(user, 'user_id', 'N/A')}
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  <div style={{ padding: '0.5rem 0' }}>
                    <li>
                      <a
                        onClick={() => {
                          history.push(`/${applicationUserType[get(user, 'type')]}/dashboard`);
                        }}
                        style={{ padding: '0.85rem 1.4rem', cursor: 'pointer', fontSize: '1.3rem', color: '#2c3e50', display: 'block', textDecoration: 'none', transition: 'background 0.2s', fontWeight: '500' }}
                        onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#f8f9fa'; e.currentTarget.style.color = '#007679'; }}
                        onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#2c3e50'; }}
                      >
                        <i className="fa fa-th-large" style={{ color: '#01a8af', width: '28px', fontSize: '1.3rem', textAlign: 'center', marginRight: '8px' }}></i>
                        Dashboard
                      </a>
                    </li>
                    
                    <li style={{ borderTop: '1px solid #ebebeb', margin: '0.4rem 0' }}></li>
                    
                    <li>
                      <a
                        onClick={() => {
                          dispatch(logoutUser(history));
                        }}
                        style={{ padding: '0.85rem 1.4rem', cursor: 'pointer', fontSize: '1.3rem', color: '#dc3545', display: 'block', textDecoration: 'none', transition: 'background 0.2s', fontWeight: '500' }}
                        onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#fff5f5'; }}
                        onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                      >
                        <i className="fa fa-sign-out" style={{ width: '28px', fontSize: '1.3rem', textAlign: 'center', marginRight: '8px' }}></i>
                        Logout
                      </a>
                    </li>
                  </div>
                </ul>
                {/* <div className="notification">
                  <a href="#">
                    <i className="fa fa-bell" aria-hidden="true"></i>
                  </a>
                  <span>{user.notifications.length}</span>
                </div> */}
                <div className="clearfix"></div>
              </div>
              <div className="clearfix"></div>
            </>
          )}
        </div>
      </header>

      <ScrollToStart addHeaderClass={addHeaderClass} />
    </>
  );
};
export default withRouter(PublicHeader);
